import { UPDATE_JOB_LISTING } from '../../endpoints';
import { JobListing } from '../../types/jobs';
import makeAuthenticatedRequest from '../base-api';

interface UpdateJobListingResponse {
  success: boolean;
  message?: string;
  jobListing?: JobListing;
}

const updateJobListingApi = async (
  payload: JobListing
): Promise<UpdateJobListingResponse> => {
  try { 
    const response = await makeAuthenticatedRequest(UPDATE_JOB_LISTING, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });

    const result = await response.json();

    if (!response.ok) {
      if (result.message) {
        throw new Error(result.message);
      } else {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
    }

    return result;
  } catch (error) {
    console.error('Update job listing failed:', error);
    throw error;
  }
};

export { updateJobListingApi, type UpdateJobListingResponse };
